import React from 'react';

import './ImageTextGroup.scss';

interface IImageTextGroupProps {
  image: string;
  text: JSX.Element | string;
  isBackgroundInversed?: boolean;
}

export function ImageTextGroup({ image, text, isBackgroundInversed }: IImageTextGroupProps) {
  return (
    <div className='ImageTextGroup'>
      <img
        src={ image }
        className={ 'ImageTextGroup__image' + (isBackgroundInversed ? ' ImageTextGroup__image--inverse-background' : '') }
        alt='my-posts'
      />
      <div className='ImageTextGroup__text'>{ text }</div>
    </div>
  );
}
